import { render } from "./FishModeChoose.vue?vue&type=template&id=afa7eab0&scoped=true"
import script from "./FishModeChoose.vue?vue&type=script&lang=js"
export * from "./FishModeChoose.vue?vue&type=script&lang=js"

import "./FishModeChoose.vue?vue&type=style&index=0&id=afa7eab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa7eab0"]])

export default __exports__